import { render, staticRenderFns } from "./QuestionsAndAnswers.vue?vue&type=template&id=7af7164a&"
import script from "./QuestionsAndAnswers.vue?vue&type=script&lang=js&"
export * from "./QuestionsAndAnswers.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsAndAnswers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports